var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect } from 'react';
import PolicyCard from './PolicyCard';
import Sheild from '../../../../icons/BusinessType/Sheild';
import Lock from '../../../../icons/BusinessType/Lock';
import Tools from '../../../../icons/BusinessType/Tools';
import PolicyStepsHeader from '../../../../../components/common/PolicyStepsHeader';
import PolicyFormProgressBar from '../../../../common/PolicyFormProgressBar';
import useWidgetStore, { CurrentTabEnum, } from '../../../../../stores/widgetStore';
import useCustomerStore from '../../../../../stores/customerStore';
import useProductStore from '../../../../../stores/productStore';
import useSaasPlatformStore from '../../../../../stores/saasPlatformStore';
import useLatestQuotesWithPolicies from '../../../../../hooks/useLatestQuotesWithPolicies';
var PolicyAuditAiRecommendedPolicies = function () {
    var _a;
    var _b = useWidgetStore(), setCurrentTab = _b.setCurrentTab, setModalOpen = _b.setModalOpen, setSelectedQuote = _b.setSelectedQuote, setApplicationDataId = _b.setApplicationDataId, setFormActive = _b.setFormActive, setAnswers = _b.setAnswers;
    var _c = useCustomerStore(), applicationFormData = _c.applicationFormData, policyAuditAiEngine = _c.policyAuditAiEngine;
    var setProduct = useProductStore().setProduct;
    var Products = useSaasPlatformStore().Products;
    var latestQuotes = useLatestQuotesWithPolicies(true);
    if (!(policyAuditAiEngine === null || policyAuditAiEngine === void 0 ? void 0 : policyAuditAiEngine.enabled))
        return null;
    var recommendedPolicies = (_a = policyAuditAiEngine.externalRecommendations) !== null && _a !== void 0 ? _a : [];
    useEffect(function () {
        if (!recommendedPolicies.length)
            return;
    }, [recommendedPolicies]);
    var handleSelection = function (id) {
        var app = applicationFormData === null || applicationFormData === void 0 ? void 0 : applicationFormData[id];
        if (!app)
            return;
        var product = Products === null || Products === void 0 ? void 0 : Products.find(function (p) { return p.id === app.productId; });
        setApplicationDataId(id);
        setAnswers(app.applicationDetails);
        setProduct(product || null);
        setFormActive(true);
        setSelectedQuote(null);
        setCurrentTab(CurrentTabEnum.POLICY);
    };
    var handleClose = function () {
        setCurrentTab(CurrentTabEnum.POLICY);
        setSelectedQuote(null);
        setModalOpen(false);
    };
    var handleBack = function () {
        setCurrentTab(CurrentTabEnum.POLICY);
        setSelectedQuote(null);
        setModalOpen(false);
    };
    var handleNext = function () {
        var first = recommendedPolicies[0];
        if (!first)
            return;
        handleSelection(first);
    };
    var policyOptions = {
        GL: {
            id: 'GL',
            icon: React.createElement(Sheild, null),
            heading: 'General Liability Insurance',
            subheading: 'Essential protection for most businesses',
            description: 'Covers third-party claims of bodily injury, property damage, and personal injury.'
        },
        Cyber: {
            id: 'Cyber',
            icon: React.createElement(Lock, null),
            heading: 'Cyber Insurance',
            subheading: 'Protection against cyber incidents',
            description: 'Provides breach response support and coverage for cyber-related events.'
        },
        WC: {
            id: 'WC',
            icon: React.createElement(Sheild, null),
            heading: 'Workers’ Compensation',
            subheading: 'Coverage for employee injuries',
            description: 'Provides wage replacement and medical benefits to employees injured in the course of employment.'
        },
        PL: {
            id: 'PL',
            icon: React.createElement(Tools, null),
            heading: 'Professional Liability',
            subheading: 'Errors and omissions coverage',
            description: 'Protects against claims arising from professional mistakes or negligence.'
        }
    };
    var isDisabled = function (id) { return !recommendedPolicies.includes(id); };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "decline-popup-container" }),
        React.createElement("div", { className: "flex flex-col min-h-full items-center" },
            React.createElement(PolicyStepsHeader, { steps: [
                    {
                        stepText: 'Coverage',
                        isStepActive: true,
                        isStepCompleted: false
                    },
                    {
                        stepText: 'Business Info',
                        isStepActive: false,
                        isStepCompleted: false
                    },
                    { stepText: 'Review', isStepActive: false, isStepCompleted: false },
                    {
                        stepText: 'Purchase',
                        isStepActive: false,
                        isStepCompleted: false
                    },
                ], backButtonText: "Close", handleBack: handleBack, handleNext: handleNext, nextButtonText: "Continue", handleClose: handleClose, hideNextButton: true }),
            (!latestQuotes || latestQuotes.length === 0) && (React.createElement("div", { className: "w-full pt-6 pb-10 px-6" },
                React.createElement(PolicyFormProgressBar, { steps: 1, activeStep: 1 }))),
            React.createElement("div", { className: "flex-1 w-full overflow-y-auto" },
                React.createElement("div", { className: "flex flex-col gap-6 px-3 md:px-4 py-3 max-w-[1300px] mx-auto" },
                    React.createElement("div", null,
                        React.createElement("h2", { className: "text-2xl md:text-3xl font-bold mb-2" }, "Recommended coverages"),
                        React.createElement("p", { className: "text-[#252846] text-sm md:text-base" }, "Based on our audit, we recommend the following coverages.")),
                    React.createElement("div", { className: "bg-[#F8FAFE] p-4 rounded-xl" },
                        React.createElement("h3", { className: "text-xl font-bold" }, "Core business protection")),
                    React.createElement(PolicyCard, __assign({}, policyOptions.GL, { selected: recommendedPolicies.includes('GL'), onClick: function () { return handleSelection('GL'); }, disabled: isDisabled('GL'), coverageType: "GL" })),
                    React.createElement("div", { className: "bg-[#F8FAFE] p-4 rounded-xl mt-4" },
                        React.createElement("h3", { className: "text-xl font-bold" }, "Protection for your employees")),
                    React.createElement(PolicyCard, __assign({}, policyOptions.WC, { selected: recommendedPolicies.includes('WC'), onClick: function () { return handleSelection('WC'); }, disabled: isDisabled('WC'), coverageType: "WC" })),
                    React.createElement(PolicyCard, __assign({}, policyOptions.Cyber, { selected: recommendedPolicies.includes('Cyber'), onClick: function () { return handleSelection('Cyber'); }, disabled: isDisabled('Cyber'), coverageType: "Cyber" })),
                    React.createElement("div", { className: "bg-[#F8FAFE] p-4 rounded-xl mt-4" },
                        React.createElement("h3", { className: "text-xl font-bold" }, "Professional services protection")),
                    React.createElement(PolicyCard, __assign({}, policyOptions.PL, { selected: recommendedPolicies.includes('PL'), onClick: function () { return handleSelection('PL'); }, disabled: isDisabled('PL'), coverageType: "PL" })),
                    React.createElement("p", { className: "text-sm" }, "For questions, contact your broker or account representative."))))));
};
export default PolicyAuditAiRecommendedPolicies;
